module.exports = __webpack_public_path__ + "static/img/sewage.35dcb4ce.svg";